import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next'
import {PrismicRichText} from '@prismicio/react'
import {useLinkResolver} from 'prismicio'
import {_404PageDocument, NavigationDocumentData} from 'prismicio-types'
import {memo} from 'react'
import {Button} from 'src/common/Button'
import {Layout} from 'src/common/Layout'
import {Meta} from 'src/common/Meta'

export const ErrorPage = memo(function ErrorPage(props: {
  navigationData: NavigationDocumentData
  page: _404PageDocument
}) {
  const {linkResolver} = useLinkResolver()
  return (
    <Layout alternateLanguages={props.page.alternate_languages} navigationData={props.navigationData}>
      <Meta
        {...(isFilled.keyText(props.page.data.meta_description) && {description: props.page.data.meta_description})}
        {...(isFilled.keyText(props.page.data.meta_title) && {title: props.page.data.meta_title})}
        {...(isFilled.image(props.page.data.meta_image) && {imageUrl: props.page.data.meta_image.url})}
      />

      <div className="-mt-12 grid min-h-screen grid-cols-main place-content-center py-30 text-center sm:-mt-16 md:py-40">
        <PrismicNextImage alt="" className="col-[inner] justify-self-center" field={props.page.data.image} />

        <PrismicRichText
          components={{
            heading1: ({children}) => (
              <h1 className="col-[inner] mt-10 text-32 font-bold leading-10 -tracking-common text-2a2928 [&_>_br]:max-md:content-[''] [&_>_br]:max-md:after:content-['_']">
                {children}
              </h1>
            ),
          }}
          field={props.page.data.title}
        />

        <PrismicRichText
          components={{
            paragraph: ({children}) => <p className="col-[inner] mt-4 text-18 leading-6 text-2a2928">{children}</p>,
          }}
          field={props.page.data.description}
        />

        <Button
          className="col-[inner] mt-10 justify-self-center"
          href={linkResolver(props.page.data.link)}
          variant="fill"
        >
          {props.page.data.link_label}
        </Button>
      </div>
    </Layout>
  )
})
